import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

const roleLabels = {
  admin:          'مدير النظام',
  sales_manager:  'مدير المبيعات',
  area_supervisor:'مشرف منطقة',
  supervisor:     'مشرف',
  salesman:       'مندوب مبيعات',
};

export default function Header({ title, showBack = false, rightAction = null }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(false);

  return (
    <>
      <header style={styles.header}>
        {/* Right: Back or Menu */}
        <div style={styles.side}>
          {showBack ? (
            <button style={styles.iconBtn} onClick={() => navigate(-1)}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                <path d="m9 18 6-6-6-6"/>
              </svg>
            </button>
          ) : (
            <button style={styles.iconBtn} onClick={() => setShowMenu(true)}>
              <div style={styles.avatar}>
                {user?.name_ar?.charAt(0) || user?.username?.charAt(0) || 'م'}
              </div>
            </button>
          )}
        </div>

        {/* Center: Title */}
        <h1 style={styles.title}>{title}</h1>

        {/* Left: Right Action */}
        <div style={styles.side}>
          {rightAction}
        </div>
      </header>

      {/* User Menu Drawer */}
      {showMenu && (
        <>
          <div style={styles.overlay} onClick={() => setShowMenu(false)} />
          <div style={styles.drawer}>
            <div style={styles.drawerUser}>
              <div style={styles.drawerAvatar}>
                {user?.name_ar?.charAt(0) || 'م'}
              </div>
              <div>
                <div style={styles.drawerName}>{user?.name_ar || user?.username}</div>
                <div style={styles.drawerRole}>{roleLabels[user?.role] || user?.role}</div>
              </div>
            </div>
            <div className="divider" />
            <button
              style={styles.logoutBtn}
              onClick={async () => { setShowMenu(false); await logout(); navigate('/login'); }}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/>
              </svg>
              تسجيل الخروج
            </button>
          </div>
        </>
      )}
    </>
  );
}

const styles = {
  header: {
    height: 'var(--nav-height)',
    background: 'white',
    borderBottom: '1px solid var(--gray-100)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 var(--space-4)',
    position: 'sticky',
    top: 0,
    zIndex: 50,
    boxShadow: '0 1px 8px rgba(0,0,0,0.05)',
  },
  side: {
    width: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    fontSize: 17,
    fontWeight: 700,
    color: 'var(--gray-900)',
    flex: 1,
    textAlign: 'center',
  },
  iconBtn: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: 4,
    borderRadius: 8,
    color: 'var(--gray-600)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  avatar: {
    width: 34,
    height: 34,
    borderRadius: '50%',
    background: 'linear-gradient(135deg, var(--primary), var(--green-400))',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 15,
    fontWeight: 700,
  },
  overlay: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.4)',
    zIndex: 200,
  },
  drawer: {
    position: 'fixed',
    top: 0,
    right: 0,
    width: 280,
    height: '100%',
    background: 'white',
    zIndex: 201,
    padding: 24,
    boxShadow: '-4px 0 20px rgba(0,0,0,0.15)',
  },
  drawerUser: {
    display: 'flex',
    alignItems: 'center',
    gap: 14,
    padding: '16px 0',
  },
  drawerAvatar: {
    width: 50,
    height: 50,
    borderRadius: '50%',
    background: 'linear-gradient(135deg, var(--primary), var(--green-400))',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 20,
    fontWeight: 700,
  },
  drawerName: {
    fontSize: 16,
    fontWeight: 700,
    color: 'var(--gray-900)',
  },
  drawerRole: {
    fontSize: 13,
    color: 'var(--gray-500)',
    marginTop: 2,
  },
  logoutBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    width: '100%',
    padding: '12px 0',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: 'var(--danger)',
    fontSize: 15,
    fontWeight: 600,
    fontFamily: 'var(--font-main)',
  },
};
